import { TitledSection } from './titledSection'

export { TitledSection }
